import "./styles/App.module.scss";
import CreateEvent from "./create-event/create-event";
import EditEvent from "./edit-event/edit-event";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import EventDisplay from "./event-display/event-display";
import LandingPage from "./landing-page/landing-page";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/create" element={<CreateEvent />} />
        <Route path="/edit/:eventId" element={<EditEvent />} />
        <Route path="/e/*" element={<EventDisplay />} />
        <Route path="*" element={<LandingPage />} />
      </Routes>
    </Router>
  );
}

export default App;
